import React,{useState, useEffect, forwardRef, useImperativeHandle} from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import ValidationMessage from '../../../../../../../../../component/common/ValidationMessage';
import AlertMessage from '../../../../../../../../../component/common/AlertMessage';
import ButtonLoader from '../../../../../../../../../component/common/ButtonLoader';
import { typeOfResponse } from '../../../../../../../../../constants/selectOptions';
const ServiceAttributeAssociationForm = forwardRef((props, ref) => {
    const { 
        formData, 
        serviceAttributeAssUpdateData,
        formActionType,
        formValidateError,
        isButtonLoader
    } = props;

    // ----- define all state ---- //
    const [ serviceAttributeAssociation, setServiceAttributeAssociation ] = useState([]);
    const [ responseType , setResponseType ] = useState('');
    const [ associationFormError, setAssociationFormError ] = useState({});
    const [ associationFormData, setAssociationFormData ] = useState({
        service_attribute_association: null,
        example: "",
        service_attribute_response: null,
        final_response: "",
        initial_response: "",
        fail_response: "",
    });

    const saAssociation = formData['step4'].service_attributes_association;
    const serviceAttributeAssData = formData['step4'].service_attributes_association_setup;

    useEffect(() => {
        if(Object.keys(saAssociation).length > 0){
            const selectAss = Object.entries(saAssociation).flatMap(
                ([serviceName, data]) => {
                    return data.attribute_list.map((attribute) => {
                        const label = `Service: ${serviceName}, Attribute: ${attribute.value}`;
                        return {
                            label,
                            value: label
                        };
                    });
                }
            );
            setServiceAttributeAssociation(selectAss)
        }
        if(serviceAttributeAssData.length > 0){
            var serviceAttrAssociatedValues = new Set(
                serviceAttributeAssData.flatMap(item => item.service_attribute_association.map(sa => sa.value))
            );
            setServiceAttributeAssociation(prevData =>
                prevData.filter(item => !serviceAttrAssociatedValues.has(item.value))
            );
        }
    },[serviceAttributeAssData, saAssociation]);


    const validateField = (name, value) => {
        let error = "";
        if(name === "service_attribute_association"){
            if (!value || value === null) {
                error = "Select association is required";
            }
        }
        if(name === "example"){
            if (!value) {
                error = "Example is required";
            }
        }
        // if(name === "service_attribute_response"){
        //     if (!value || value === null) {
        //         error = "Response is required";
        //     }
        // }
        // if(responseType === 'static_response'){
            if(name === "final_response"){
                if (!value) {
                    error = "Final response is required";
                }
            }
        // }
        return error;
    }
    const othersInputOnchange = (selectedOption, actionMeta) => {
        if (actionMeta?.name) {
            // ------- manage select field --------- //
            const { name } = actionMeta;
            if(name === 'service_attribute_response'){
                setResponseType(selectedOption.value)
            }
           
            const fieldError = validateField(name, selectedOption);
            setAssociationFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setAssociationFormData((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
        }
        else if(selectedOption?.target){
            // ----- manage input field -------- //
            const { name, value } = selectedOption.target;
            
            let newVal = value;

            // const fieldsToValidate = ['example'];
            // if (fieldsToValidate.includes(name)) {
            //     newVal = specialCharacterValidate(newVal);
            // }

            const fieldError = validateField(name, value);
            setAssociationFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setAssociationFormData((prevData) => ({
                ...prevData,
                [name]: newVal,
            }));
        }
    }

    const serviceAttributeAssociateSaveHandler = (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in associationFormData) {
            newErrors[key] = validateField(key, associationFormData[key]);
        }
        setAssociationFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            props.saveServiceAttributeAssociate(associationFormData)
        }
    }

    useImperativeHandle(ref, () => ({
        resetForm: () => {
            setAssociationFormData((prevState) => ({
                ...prevState,
                service_attribute_association: null,
                example: "",
                service_attribute_response: null,
                final_response: "",
                initial_response: "",
                fail_response: "",
            }));
            setResponseType('')
        }
    }));

    useEffect(() => {
        if(serviceAttributeAssUpdateData.length > 0){
            if(formActionType === 'update'){
                let serviceAttrAssUpData = serviceAttributeAssUpdateData[0]
                setAssociationFormData((prevState) => ({
                    ...prevState,
                    service_attribute_association : serviceAttrAssUpData.service_attribute_association,
                    example : serviceAttrAssUpData.example,
                    service_attribute_response : serviceAttrAssUpData.service_attribute_response,
                    final_response : serviceAttrAssUpData.final_response,
                    initial_response : serviceAttrAssUpData.initial_response,
                    fail_response : serviceAttrAssUpData.fail_response,
                }));
            }
            else{
                setAssociationFormData((prevState) => ({
                    ...prevState,
                    service_attribute_association: null,
                    example: "",
                    service_attribute_response: null,
                    final_response: "",
                    initial_response: "",
                    fail_response: "",
                }));
            }
        }
    },[serviceAttributeAssUpdateData]);

    const infoPopupData = {
        'add_example' : {
            'title' : 'Add example',
            'info' : `Provide an example of how your customer would provide information. For example, "My First Name is Cristina?" or just "Cristina", or "871098761"  etc.`,
        },
        'select_type_of_response' :{
            'title' : 'Type of response',
            'info' : `Static Response is a pre-determined answer that you provide. The Agent will provide the same response everytime. Use DB Response when you want the Agent to Fetch responses from a DB. Note that you need to integrate the Query with an API end-point we provide for this. Use API response for fetching reponse from another system like a CRM, or using an LLM. Here to you need to integrate the API using the endpoints we provide.`
        }
    }

    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }

    return (
        <>
            <div className='row'>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Select Association
                    </label>
                    <Select
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={serviceAttributeAssociation}
                        placeholder='Select an option'
                        name="service_attribute_association"
                        onChange={othersInputOnchange}
                        value={associationFormData.service_attribute_association}
                    />
                    {
                        associationFormError.service_attribute_association &&
                        <ValidationMessage
                            className='text-danger' 
                            message ={associationFormError.service_attribute_association}
                        />
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Add Example User Response
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('add_example')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter attribute"
                        name="example"
                        onChange={othersInputOnchange}
                        value={associationFormData.example}
                    />
                    {
                        associationFormError.example &&
                        <ValidationMessage
                            className='text-danger' 
                            message ={associationFormError.example}
                        />
                    }
                </div>
                {/* <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Select Type Of Response
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('select_type_of_response')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    
                    <Select
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={typeOfResponse}
                        placeholder='Select an option'
                        name="service_attribute_response"
                        onChange={othersInputOnchange}
                        value={associationFormData.service_attribute_response}
                    />
                    {
                        associationFormError.service_attribute_response &&
                        <ValidationMessage
                            className='text-danger' 
                            message ={associationFormError.service_attribute_response}
                        />
                    }
                </div> */}
                {/* {
                    responseType === 'static_response' &&
                    <> */}
                        <div className='col-md-12 mb-5'>
                            <label className="form-label">
                                Add Initial Response
                            </label>
                            <textarea 
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter initial response' 
                                name="initial_response"
                                onChange={othersInputOnchange}
                                value={associationFormData.initial_response}
                            ></textarea>
                        </div>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Add Final Response
                            </label>
                            <textarea 
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter final response' 
                                name='final_response'
                                onChange={othersInputOnchange}
                                value={associationFormData.final_response}
                            ></textarea>
                            {
                                associationFormError.final_response &&
                                <ValidationMessage
                                    className='text-danger' 
                                    message ={associationFormError.final_response}
                                />
                            }
                        </div>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label">
                                Add Fail Response
                            </label>
                            <textarea
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter fail response' 
                                name="fail_response"
                                onChange={othersInputOnchange}
                                value={associationFormData.fail_response}
                            ></textarea>
                        </div>
                    {/* </>
                } */}
                <div className='col-md-12 m-auto text-end mb-3'>
                    {
                        formActionType === 'insert' &&
                        <div 
                            className={`btn btn-dark btn-icon btn-sm ${isButtonLoader ? 'disabled' : ''}`}
                            onClick={serviceAttributeAssociateSaveHandler}
                        >
                            {
                                isButtonLoader ?
                                <ButtonLoader/>
                                :
                                <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                            }
                        </div>
                    }
                    {
                        formActionType === 'update' &&
                        <div 
                            className={`btn btn-primary btn-sm ${isButtonLoader ? 'disabled' : ''}`} 
                            onClick={serviceAttributeAssociateSaveHandler}
                        >
                            {
                                isButtonLoader ? 
                                <ButtonLoader
                                    btnHtml='Please wait...'
                                    className='me-2'
                                />
                                :
                                'Update'
                            }
                        </div>
                    }
                </div>
                {
                    formValidateError?.service_attributes_association_setup &&
                    <AlertMessage
                        sub_title = {formValidateError?.service_attributes_association_setup}
                        type = 'danger'
                    />
                }
            </div>
        </>
    )
})
export default ServiceAttributeAssociationForm